import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LocalStorage } from 'ngx-webstorage';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '@motes-sdk/components/svg-icon';
import { AutoSub, AutoSubOnDestroy } from '@motes-sdk/providers';
import { MapOverlayService } from '../../../../services/map-overlay.service';

@AutoSubOnDestroy()
@Component({
    selector: 'waypoint-help',
    standalone: true,
    imports: [CommonModule, SvgIconModule],
    templateUrl: './waypoint-help.component.html',
    styleUrls: ['./waypoint-help.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WaypointHelpComponent implements OnInit {

    @LocalStorage('isWaypointHelpOpen', true) public open: boolean;

    public disabled: boolean = false;

    constructor(private mapOverlayService: MapOverlayService) { }

    ngOnInit(): void {

        AutoSub(this).reg['activeToolSub'] = this.mapOverlayService.watchActiveTool().subscribe((activeTool) => {
            this.disabled = Boolean(activeTool);
            if(activeTool == 'select-tour-type') this.open = false;
        })
    }

    public toggleOpen() {
        if(!this.disabled) this.open = !this.open;
        // Clear any open features or tools on map
        this.mapOverlayService.updateActiveTool(false, null);
    }

}
